import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
	selector: 'tmhna-portal-customer-portal',
	templateUrl: './customer-portal.component.html',
	styleUrls: ['./customer-portal.component.scss']
})
export class CustomerPortalComponent implements OnInit 
{

	businessAccount = 'Business Account Requests';
	inviteUsers = 'Invite Users';
	customerSupport = 'Impersonate User';
	pageTitle = 'User Management';
	public activeTab: string = '';
	tabIndex: number = 0;
	constructor() { }
	ngOnInit(): void 
	{
		const endCorpSession = localStorage.getItem('endCorpSession');
		if(endCorpSession && endCorpSession !== null )
		{
			this.activeTab = this.customerSupport;
			this.tabIndex = 2;
			localStorage.removeItem('endCorpSession');
		}
		else
		{
			this.tabIndex = 0;
			this.activeTab= this.businessAccount;
		}
	}

	updateTabView(event: MatTabChangeEvent) 
	{
		this.activeTab = event.tab.textLabel;
	}
}


